// src/utils/shotFieldLayout.js

const LS_KEY = "shotFieldLayout.v1";

// Les clés doivent matcher EXACTEMENT les noms de champs de tes shots
export const DEFAULT_SHOT_FIELD_LAYOUT = [
  // --- Champs qui impactent les TAGS (ordre + style)
  { key: "shotSize", label: "Échelle", tagColor: "#2B3550", tagBold: false },
  { key: "shotType", label: "Type",    tagColor: "#2B3550", tagBold: false },
  { key: "framing",  label: "Cadre",   tagColor: "#2B3550", tagBold: false },
  { key: "focus",    label: "Focus",   tagColor: "#2B3550", tagBold: false },
  { key: "movement", label: "Mvt",     tagColor: "#2B3550", tagBold: false },
  { key: "durationEstimateSec", label: "Temps", tagColor: "#2B3550", tagBold: true },

  // --- Champs du Shot Editor (mais pas affichés en tags)
  { key: "description", label: "Description", tagColor: "#2B3550", tagBold: false },
  { key: "image", label: "Image", tagColor: "#2B3550", tagBold: false },
  { key: "linkedShots", label: "Plan lié", tagColor: "#2B3550", tagBold: false },
];

export function loadShotFieldLayout() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return DEFAULT_SHOT_FIELD_LAYOUT;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return DEFAULT_SHOT_FIELD_LAYOUT;

    // Merge safe (au cas où tu ajoutes des champs plus tard)
    const byKey = new Map(parsed.map((x) => [x.key, x]));
    return DEFAULT_SHOT_FIELD_LAYOUT.map((d) => ({ ...d, ...(byKey.get(d.key) || {}) }));
  } catch {
    return DEFAULT_SHOT_FIELD_LAYOUT;
  }
}

export function saveShotFieldLayout(layout) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(layout));
  } catch {}
}
